import { isMobile } from "../../scripts/helpers";

export default class FilterResults {
  constructor() {
    var filter = document.querySelector('.filter-menu');
    var linkOpenFilter = document.querySelector('[data-open="filter-menu"]');

    if(isMobile() && typeof(filter) != 'undefined' && filter != null && typeof(linkOpenFilter) != 'undefined' && linkOpenFilter != null) {
      var html = document.querySelector('html');
      var self = this;
      var linksOpenFilter = document.querySelectorAll('[data-open="filter-menu"]');

      linksOpenFilter.forEach(element => {
        element.addEventListener('click', function(e) {
          e.preventDefault();
          console.log('clicou');
  
          self.toggleFilter(filter, html);
        });
      });
    }
  }; 
  
  toggleFilter(filter, html) {
    filter.classList.contains('filter-menu--active') ? this.closeFilter(filter, html) : this.openFilter(filter, html);
  }

  openFilter(filter, html) {
    filter.classList.add('filter-menu--active');
    html.classList.contains('overflowed') ? null : html.classList.add('overflowed');
  }

  closeFilter(filter, html) {
    filter.classList.remove('filter-menu--active');
    html.classList.contains('overflowed') ? html.classList.remove('overflowed') : null;
  }
}

const filterResults = new FilterResults();